import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

const hotMovies = movies.filter((m) => m.isHot).slice(0, 5);

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % hotMovies.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const movie = hotMovies[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={movie.bannerImage}
          alt={movie.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-background-50"></div>
      </div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 md:px-6 w-full">
        <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-3">
          哈哈影院
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-xl mb-6">
          高清免费在线观看 · 海量影视大全 · 播放不缓冲
        </p>

        <div className="relative w-full max-w-md mb-8">
          <input
            type="text"
            placeholder="搜索你想看的电影、电视剧..."
            className="w-full pl-12 pr-5 py-3.5 rounded-full bg-white/15 backdrop-blur-md border border-white/20 text-white placeholder:text-white/50 text-sm focus:outline-none focus:border-white/40 focus:ring-2 focus:ring-white/20 transition-all"
          />
          <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-white/60 text-lg w-5 h-5 flex items-center justify-center"></i>
        </div>

        <div className="flex items-center gap-3 flex-wrap justify-center">
          {hotMovies.map((m, i) => (
            <button
              key={m.id}
              onClick={() => setCurrent(i)}
              className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                i === current
                  ? 'bg-primary-500 w-7'
                  : 'bg-white/40 hover:bg-white/60'
              }`}
              aria-label={`切换到 ${m.title}`}
            />
          ))}
        </div>

        <div className="mt-6">
          <Link
            to={`/article/${movie.id}`}
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line w-4 h-4 flex items-center justify-center"></i>
            了解详情
          </Link>
        </div>

        <div className="mt-4">
          <p className="text-white/70 text-sm">
            正在热播：<strong className="text-white">{movie.title}</strong>
            <span className="mx-2 text-white/40">|</span>
            评分 <strong className="text-accent-400">{movie.rating}</strong>
          </p>
        </div>
      </div>
    </section>
  );
}